import React from 'react';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from 'reducers/selectors/metadata';
import LoginV1 from './Login';
import LoginV2 from './../LoginV2';

export const Login = ({ asset, translations }) => {
  const landingConfig = useSelector(
    selectMetadataKeyByRegion('landing_telmex_config'),
  );

  return landingConfig?.enable ? (
    <LoginV2 />
  ) : (
    <LoginV1 asset={asset} translations={translations} />
  );
};

export default Login;
